import { fetch , post } from "../plugin/fetch";
import Vue from 'vue'
import { Dialog } from 'vant'
Vue.use(Dialog);
export default {
    namespaced: true,
    state: {
        select: '' ,
        select1: '' ,
        userInfo : {} ,
        productList : {} ,
        addressList : {},
        bankList : {},
        AlipayList : {},
        addAddress : {} ,
        addBank : {} ,
        deleteBank : {} ,
        deleteAddress : {} ,
        defaultAddress : {} ,
        defaultAlipay: {} ,
        defaultBank : {} ,
        addressDetail : {},
        aditAddress : {} ,
        bankDetail : {},
        aditbank : {} ,
        exchange : {} ,
        goodsExchange : {} ,
        allbanne : {} ,
        Useruid : {} ,
        allocation : {},
        chosenList: {} ,
        Syssetting: {} ,
        sletId : '',
        sletId2 : '',
        GoodsDetail:'',
        // count:10,
    },
    mutations: {
        setselect(state,data){
            state.select = data;
        },
        // setCount(state,data){
        //     state.count = data;
        // },
        setselect1(state,data){
            state.select1 = data;
        },
        setsletId(state,data){
            state.sletId = data;
        },
        setsletId2(state,data){
            state.sletId2 = data;
        },
        setUserInfo(state,data){
            state.userInfo = data;
        },
        setAddressList(state,data){
            state.addressList = data;
        },
        setBankList(state,data){
            state.bankList = data;
        },
        setAlipayList(state,data){
            state.AlipayList = data;
        },
        setAddAddress(state,data){
            state.addAddress = data;
        },
        setAddBank(state,data){
            state.addBank = data;
        },
        setDeleteBank(state,data){
            state.deleteBank = data;
        },
        setDeleteAddress(state,data){
            state.deleteAddress = data;
        },
        setProductList(state,data){
            state.productList = data;
        },
        setDefaultAddress(state,data){
            state.defaultAddress = data;
        },
        setdefaultAlipay(state,data){
            state.defaultAlipay = data;
        },
        setDefaultBank(state,data){
            state.defaultBank = data;
        },
        setAddressDetail(state,data){
            state.addressDetail = data;
        },
        setEditAddress(state,data){
            state.aditAddress= data;
        },
        setBankDetail(state,data){
            state.bankDetail = data;
        },
        setEditAddress(state,data){
            state.editBank = data;
        },
        setExchange(state,data){
            state.exchange = data;
        },
        setGoodsExchange(state,data){
            state.goodsExchange = data;
        },
        setAllbanne(state,data){
            state.allbanne = data;
        },
        setUserUid(state,data){
            state.UserUid = data;
        },
        setAllocation(state,data){
            state.allocation = data;
        },
        setChosenList(state,data){
            state.chosenList = data;
        },
        setSyssetting(state,data){
            state.Syssetting = data;
        },
        setGoodsDetail(state,data){
            state.GoodsDetail = data;
        },
    },
    actions: {
        //获取用户平台id
        fetchUserUid({commit},data) {
            return new Promise((resolve,reject) => {
                fetch('/api/user/uid',data).then(res => {
                    if (res.code==200) {
                        // console.log(res.data)
                        commit('setUserUid', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //获取系统配置
        fetchSyssetting({commit},data) {
            return new Promise((resolve,reject) => {
                fetch('/api/config/syssetting',data).then(res => {
                    if (res.code==200) {
                        // console.log(res.data)
                        commit('setSyssetting', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //轮播广告
        fetchAllbanner({commit},data) {
            // console.log(data)
            return new Promise((resolve,reject) => {
                fetch('/api/ad/list',data).then(res => {
                    if (res.code==200) {
                        commit('setAllbanne', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //个人信息
        fetchHome({commit},data) {
            // console.log(data)
            return new Promise((resolve,reject) => {
                fetch('/api/user/info',data).then(res => {
                    if (res.code==200) {
                        commit('setUserInfo', res.data);
                        resolve()
                    }
                });
            });
        },
        //获取商品列表
        fetchProductList ({commit},data) {
            // console.log(data)
            return new Promise((resolve,reject) => {
                fetch('/api/goods/list',data).then(res => {
                    if (res.code==200) {
                        commit('setProductList', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //精选商品列表
        fetchChosenList ({commit},data) {
            // console.log(data)
            return new Promise((resolve,reject) => {
                fetch('/api/goods/list/',data).then(res => {
                    if (res.code==200) {
                        commit('setChosenList', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //添加收货信息
        fetchAddAddress({commit},data) {
            // console.log(data)f
            return new Promise((resolve,reject) => {
                post('/api/address/add',data).then(res => {
                    // if (res.code==200) {
                        commit('setAddAddress', res.data);
                        resolve(res)
                    // }else{
                    //     Dialog.alert({
                    //         title:'提醒',
                    //         message: '添加地址失败'
                    //     })
                    // }
                });
            });
        },
        //添加支付宝
        fetchAlipays({commit},data) {
            // console.log(data)f
            return new Promise((resolve,reject) => {
                post('/api/alipays/add',data).then(res => {
                    if (res.code==200) {
                        commit('setAlipays', res.data);
                        resolve()
                    }else{
                        Dialog.alert({
                            title:'提醒',
                            message: '添加支付宝失败'
                        })
                    }
                });
            });
        },
        //收货列表
        fetchAddressList({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/address/list' , data).then(res => {
                    if (res.code==200) {
                        commit('setAddressList', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //获取一个收货地址
        fetchAddressDetail({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/address/detail' , data).then(res => {
                    console.log(res.data)
                    if (res.code==200) {
                        commit('setAddressDetail', res.data);
                        resolve(res.data)
                    }
                });
            });
        },
        //获取一个收货地址
        fetchAlipayDetail({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/alipays/detail' , data).then(res => {
                    console.log(res.data)
                    if (res.code==200) {
                        // commit('setAddressDetail', res.data);
                        resolve(res.data)
                    }
                });
            });
        },
        //修改一个收货地址
        fetchEditAddress({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/address/edit',data).then(res => {
                    if (res.code==200) {
                        commit('setEditAddress', res.data);
                        resolve()
                    }else{
                        Dialog.alert({
                            title:'提醒',
                            message: '修改收货地址失败'
                        })
                    }
                });
            });
        },
        //设置默认地址
        fetchDefaultAddress({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/address/default',data).then(res => {
                    if (res.code==200) {
                        commit('setDefaultAddress', res.data);
                        // alert('删除成功')
                        resolve(res.data)
                    }else{
                        // alert('删除失败')
                    }
                });
            });
        },
        //设置支付宝s
        fetchDefaultAlipay({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/alipays/default',data).then(res => {
                    if (res.code==200) {
                        commit('setdefaultAlipay', res.data);
                        // alert('删除成功')
                        resolve(res.data)
                    }else{
                        // alert('删除失败')
                    }
                });
            });
        },
        //删除收货地址
        fetchDeleteAddress({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/address/delete',data).then(res => {
                    if (res.code==200) {
                        commit('setDeleteAddress', res.data);
                        resolve()
                    }else{
                        Dialog.alert({
                            title:'提醒',
                            message: '删除收货地址失败'
                        })
                    }
                });
            });
        },
        //删除支付宝s
        fetchDeleteAlipay({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/alipays/delete',data).then(res => {
                    if (res.code==200) {
                        // commit('setDeleteAddress', res.data);
                        resolve()
                    }else{
                        Dialog.alert({
                            title:'提醒',
                            message: '删除支付宝信息失败'
                        })
                    }
                });
            });
        },
        //添加银行信息
        fetchAddBank({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/bank/add',data).then(res => {
                    // if (res.code==200) {
                        commit('setAddBank', res.data);
                        resolve(res)
                    // }else{
                    //     Dialog.alert({
                    //         title:'提醒',
                    //         message: '添加提现信息失败'
                    //     })
                    // }
                });
            });
        },
        
        //银行列表
        fetchBankList({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/bank/list' , data).then(res => {
                    // console.log(res.data)
                    if (res.code==200) {
                        commit('setBankList', res.data);
                        resolve(res)
                    }else{
                        resolve(res)
                    }
                });
            });
        },
        //支付宝列表
        fetchAlipayList({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/alipays/list' , data).then(res => {
                    // console.log(res.data)
                    if (res.code==200) {
                        commit('setAlipayList', res.data);
                        resolve(res)
                    }else{
                        resolve(res)
                    }
                });
            });
        },
        //设置默认银行卡
        fetchDefaultBank({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/bank/default',data).then(res => {
                    if (res.code==200) {
                        commit('setDefaultBank', res.data);
                        // alert('删除成功')
                        resolve()
                    }else{
                        // alert('删除失败')
                    }
                });
            });
        },
        //删除银行卡
        fetchDeleteBank({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/bank/delete',data).then(res => {
                    if (res.code==200) {
                        commit('setDeleteBank', res.data);
                        resolve()
                    }else{
                        Dialog.alert({
                            title:'提醒',
                            message: '删除提现信息失败'
                        })
                    }
                });
            });
        },
        //获取一个收货地址
        fetchBankDetail({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/bank/detail' , data).then(res => {
                    console.log(res.data)
                    if (res.code==200) {
                        commit('setBankDetail', res.data);
                        resolve(res.data)
                    }
                });
            });
        },
        //修改一个收货地址
        fetchEditBank({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/bank/edit',data).then(res => {
                    if (res.code==200) {
                        commit('setEditBank', res.data);
                        resolve(res.data)
                    }else{
                        Dialog.alert({
                            title:'提醒',
                            message: '修改提现信息失败'
                        })
                    }
                });
            });
        },
        //修改支付宝
        fetchEditAlipay({commit},data) {
            return new Promise((resolve,reject) => {
                post('/api/alipays/edit',data).then(res => {
                    if (res.code==200) {
                        commit('setEditAlipay', res.data);
                        resolve(res.data)
                    }else{
                        Dialog.alert({
                            title:'提醒',
                            message: '修改提现信息失败'
                        })
                    }
                });
            });
        },
        //总换一个商品
        fetchGoodsExchange({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/goods/exchange' , data).then(res => {
                    if (res.code==200) {
                        commit('setGoodsExchange', res.data);
                        resolve(res)
                    }else{
                        resolve(res)
                    }
                });
            });
        },
        //获取用户兑换记录
        fetchExchange({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/user/exchange' , data).then(res => {
                    if (res.code==200) {
                        commit('setExchange', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //配置key值
        fetchAllocation({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/config/all' , data).then(res => {
                    if (res.code==200) {
                        commit('setAllocation', res.data);
                        resolve(res.data)
                    }
                });
            });
        },
        //获取商品详细
        fetchGoodsDetail({ commit } , data) { 
            return new Promise((resolve,reject) => {
                fetch('/api/goods/detail' , data).then(res => {
                    if (res.code==200) {
                        commit('setGoodsDetail', res.data);
                        resolve(res.data)
                    }
                });
            });
        },
    },
}